export default __webpack_public_path__ + "static/media/chevron-down.a2b79e51.svg";